import { Box } from "@obs/components";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

import { AccountContextType } from "../Components/Account/AccountProvider";
import { GoogleTagManager } from "../Components/GoogleTagManager";

export const Route = createRootRouteWithContext<{
	account: AccountContextType;
}>()({
	component: RootComponent,
});

function RootComponent() {
	return (
		<>
			<GoogleTagManager />
			<Box
				sx={{
					display: "flex",
					height: "100vh",
					flexDirection: "column",
				}}
			>
				<Outlet />
			</Box>
		</>
	);
}
